<div class="container" [ngSwitch]="showList">
    <div class="d-flex align-items-center mb-4">
        <h1 class="mb-0 me-3"><i class="far fa-users text-primary"></i> Manage Users</h1>
        <button type="button" (click)="viewUser(null)" class="btn btn-round btn-primary text-uppercase text-strong hvr-grow"><i class="far fa-plus"></i>
            New User</button>
    </div>
    <div class="card round-corners heavy-shadow p-3 mb-3">
        <div class="row align-items-end gx-2 mb-xxl-3">
            <div class="col-xxl-6 col-xl-6 mb-3 mb-xxl-0">
                <label class="form-label">User's Name</label>
                <input type="text" class="form-control form-control-lg" placeholder="User's Name" (keydown)="inputFieldChange($event)" (ngModelChange)="hideTheList()" [(ngModel)]="filter.nameFilter" />
            </div>
            <div class="col-xxl-3 col-xl-6 mb-3 mb-xxl-0">
                <label class="form-label">Status</label>
                <div class="w-100" ngbDropdown>
                    <button class="btn btn-white btn-lg w-100" ngbDropdownToggle type="button" id="dropdownMenuButton1" aria-expanded="false">
                        <span>{{filter.userStatus.text}}</span>
                    </button>
                    <ul class="w-100" ngbDropdownMenu aria-labelledby="dropdownMenuButton1">
                        <ng-container *ngFor="let f of statusFilters">
                            <li *ngIf="filter.userStatus.value !== f.value"><a ngbDropdownItem class="dropdown-item" href="javascript:void(0)" (click)="selectStatusFilter(f)">{{f.text}}</a></li>
                        </ng-container>
                    </ul>
                </div>
            </div>
            <div class="col-xxl-3 col-xl-6 mb-3 mb-xxl-0">
                <label class="form-label">Role</label>
                <div class="w-100" ngbDropdown>
                    <button class="btn btn-white btn-lg w-100" ngbDropdownToggle type="button" id="dropdownMenuButton1" aria-expanded="false">
                        <span>{{filter.userPermission.text}}</span>
                    </button>
                    <ul class="w-100" ngbDropdownMenu aria-labelledby="dropdownMenuButton1">
                        <ng-container *ngFor="let f of userPermissionList">
                            <li *ngIf="filter.userPermission.value !== f.value"><a ngbDropdownItem class="dropdown-item" href="javascript:void(0)" (click)="selectUserPermission(f)">{{f.text}}</a></li>
                        </ng-container>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row align-items-end gx-2">
            <div class="col-xxl-4 col-xl-6 mb-3 mb-xxl-0 mobiscroll-select">
                <label class="form-label d-block">Top Level Account</label>
                <input mbsc-select id="filter-account-input" class="mobi-input form-control form-control-lg" [(ngModel)]="filter.accountId" placeholder="Select Top Level Account" [data]="accounts" [mbscOptions]="selectOptions" />
            </div>
            <div class="col-xxl-4 col-xl-6 mb-3 mb-xxl-0 mobiscroll-select">
                <label class="form-label d-block">Entity</label>
                <input mbsc-select id="filter-account-input2" class="mobi-input form-control form-control-lg" [(ngModel)]="filter.entityId" placeholder="Select Entity" [data]="entities" name="entityId" [mbscOptions]="parentOptions" />
            </div>
            <div class="col-xl-4 col-xl mb-3 mb-xl-0">
                <div class="row gx-2 justify-content-xxl-end justify-content-center search-btns">
                    <div class="col">
                        <button type="button" class="btn btn-secondary btn-round btn-lg text-uppercase text-strong w-100" (click)="showTheList()"><i class="far fa-search"></i> Search</button>
                    </div>
                    <div class="col">
                        <button type="button" class="btn btn-white btn-round btn-lg text-uppercase text-strong w-100" (click)="resetFilters()"><i class="far fa-times"></i> Clear</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card round-corners heavy-shadow p-3 text-center" *ngSwitchCase="false">
        <h3>Search Users</h3>
        <p>Enter search parameters above to find users.</p>
        <div class="mx-auto">
            <button type="button" class="btn btn-round btn-outline-secondary text-uppercase text-strong" (click)="showTheList()">Show All</button>
        </div>
    </div>
    <div class="card round-corners heavy-shadow p-3 text-center" *ngSwitchCase="true">
        <div class="d-flex flex-column flex-md-row justify-content-md-between justify-content-center align-items-center mb-3">
            <div class="text-left">
                <h4 class="mb-md-0">{{filter.showing(results.recordsFiltered)}}</h4>
                <div class="mt-2">
                    <a class="text-decoration-underline me-2" href="javascript:void(0);" *ngIf="results.recordsFiltered > 0" (click)="selectAll()"><i class="far fa-check"></i> Select {{results.recordsFiltered}}</a>
                    <a class="text-decoration-underline" href="javascript:void(0);" *ngIf="results.recordsFiltered > 0" (click)="exportUsers()"><i class="far fa-file-export"></i> Export All</a>
                </div>
            </div>
            <button type="button" class="btn btn-round btn-white text-strong btn-shadow" [ngClass]="{'notifyTrueStack': selectedUserService.Count() != 0, 'notifyStack': selectedUserService.Count() == 0}" (click)="messageUsers()">
                <span class="fa-stack fa-2x">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="far fa-envelope fa-stack-1x fa-inverse"></i>
                </span> {{selectedUserService.Count()}} Users Selected
            </button>
        </div>
        <div class="card no-shadow rounded border">
            <table class="table table-striped table-hover align-middle m-0">
                <thead>
                    <tr>
                        <th class="min-tablet-l">
                            <table-sorting [(col)]="filter.sortedColumn" [(dir)]="filter.sortedDirection" colName="Name" [cb]="loadList"></table-sorting>
                        </th>
                        <th class="min-tablet-l">Role</th>
                        <th class="min-tablet-l">Top Level Account</th>
                        <th class="min-tablet-l">
                            <table-sorting [(col)]="filter.sortedColumn" [(dir)]="filter.sortedDirection" colName="Last Login" [cb]="loadList"></table-sorting>
                        </th>
                        <th class="min-tablet-l">
                            <table-sorting [(col)]="filter.sortedColumn" [(dir)]="filter.sortedDirection" colName="Status" [cb]="loadList"></table-sorting>
                        </th>
                        <th class="min-tablet-l no-sort text-right"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let user of results.data" [ngClass]="{'notifyTrue': selectedUserService.Contains(user.userId)}">
                        <td>
                            <div class="d-flex align-items-center">
                                <div class="me-2" *ngIf="!user.backgroundImage">
                                    <div class="avatar avatar-sm">{{user.initials}}</div>
                                </div>
                                <div class="me-2" *ngIf="user.backgroundImage">
                                    <div class="avatar avatar-sm" [ngStyle]="{'background-image': user.backgroundImage}"></div>
                                </div>
                                <div>
                                    <span class="text-500">{{user.fullName}}</span>
                                    <small class="d-block" *ngIf="user.title">{{user.title}}</small>
                                </div>
                            </div>
                        </td>
                        <td>
                            <ul class="list-unstyled d-flex m-0">
                                <li class="me-1" *ngIf="user.isPDxAdmin">
                                    <h5 class="m-0"><span class="badge rounded-pill bg-primary">PDx
                                            Admin</span></h5>
                                </li>
                                <li class="me-1" *ngFor="let p of user.permissions">
                                    <h5 class="m-0"><span class="badge rounded-pill bg-dark">{{p}}</span></h5>
                                </li>
                            </ul>
                        <td>
                            <ng-template #accountPopover>
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item" *ngFor="let a of user.accounts">{{a}}</li>
                                </ul>
                            </ng-template>
                            <ng-container *ngIf="user.accounts.length == 1">{{user.accounts[0]}}</ng-container>
                            <a href="javascript:void(0)" [ngbPopover]="accountPopover" *ngIf="user.accounts.length > 1">{{user.accounts.length}}
                                Accounts</a>
                        </td>
                        <td>{{user.lastLogin | localDate}}</td>
                        <td [ngClass]="{'text-danger': !user.active}">{{user.activeDisplay}}</td>
                        <td class="text-right">
                            <button type="button" class="notify-btn btn btn-lg btn-white btn-shadow action-btn me-xl-2" autocomplete="off" *ngIf="!selectedUserService.Contains(user.userId)" (click)="selectedUserService.AddUserSummary(user)"><i class="far fa-envelope"></i></button>
                            <button type="button" class="btn btn-lg btn-white btn-shadow action-btn me-xl-2 active" autocomplete="off" aria-pressed="true" *ngIf="selectedUserService.Contains(user.userId)" (click)="selectedUserService.RemoveUser(user.userId)"><i class="fas fa-times text-danger"></i></button>
                            <div ngbDropdown class="d-inline-block">
                                <button class="btn btn-lg btn-white btn-shadow no-caret action-btn" type="button" id="dropdownMenuButton1" ngbDropdownToggle aria-expanded="false">
                                    <i class="far fa-ellipsis-v"></i>
                                </button>
                                <ul class="dropdown-menu-end" ngbDropdownMenu aria-labelledby="dropdownMenuButton1">
                                    <li *ngIf="user.active && !user.isPDxAdmin"><a class="dropdown-item" ngbDropdownItem href="javascript:void(0)" (click)="impersonateUser(user.userId)"><i class="far fa-theater-masks fa-fw"></i> Impersonate</a></li>
                                    <li *ngIf="user.active"><a class="dropdown-item" ngbDropdownItem href="javascript:void(0)" (click)="sendPasswordReset(user.userId)"><i class="far fa-lock fa-fw"></i> Send Password Reset</a></li>
                                    <li *ngIf="user.active"><a class="dropdown-item" ngbDropdownItem href="javascript:void(0)" (click)="viewUser(user.userId)"><i class="far fa-pencil fa-fw"></i> Edit User Profile</a></li>
                                    <li *ngIf="user.active && !user.isPDxAdmin"><a class="dropdown-item" ngbDropdownItem href="javascript:void(0)" (click)="viewUserPermissions(user.userId)"><i class="far fa-pencil fa-fw"></i> Edit User Permissions</a></li>
                                    <li *ngIf="!user.active"><a class="dropdown-item" ngbDropdownItem href="javascript:void(0)" (click)="activateUser(user.userId)"><i class="far fa-check fa-fw"></i> Activate</a></li>
                                    <li *ngIf="!user.active"><a class="dropdown-item text-danger" ngbDropdownItem href="javascript:void(0)" (click)="deleteUser(user.userId)"><i class="far fa-trash-alt fa-fw"></i> Delete</a></li>
                                    <li *ngIf="!user.isPDxAdmin"><a class="dropdown-item" ngbDropdownItem href="javascript:void(0)" (click)="syncFavorites(user.userId)"><i class="far fa-arrow-right-arrow-left fa-fw"></i> Sync Favorites</a></li>
                                </ul>
                            </div>
                        </td>

                    </tr>
                    <tr *ngIf="results.data.length == 0">
                        <td colspan="6" class="text-center">No Results</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="p-3 d-md-flex align-items-center justify-content-md-between justify-content-center text-center text-md-left">
            <p class="m-md-0 mb-3">{{filter.showing(results.recordsFiltered)}}</p>
            <ngb-pagination [(page)]="filter.page" [pageSize]="filter.pageSize" [collectionSize]="results.recordsFiltered" (pageChange)="loadList(false)" size="lg" [maxSize]="5" [rotate]="true" [ellipses]="false" [boundaryLinks]="true"></ngb-pagination>
        </div>
        <form novalidate #exportForm ngNoForm name="exportForm" method="post" action="/Users">
            <input type="hidden" name="nameFilter" [(ngModel)]="filter.nameFilter" />
            <input type="hidden" name="accountId" [(ngModel)]="filter.accountId" />
            <input type="hidden" name="userStatus.value" [(ngModel)]="filter.userStatus.value" />
            <input type="hidden" name="userPermission.value" [(ngModel)]="filter.userPermission.value" />
        </form>
    </div>
</div>